import styled from 'styled-components'
import { COLOURS } from 'resources'

export const CenterContainer = styled.div`
  padding-top: 40px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const JackpotContainer = styled.div`
  display: grid;
  grid-template-areas:
    'logo title'
    'logo values'
    'content content';
  grid-template-columns: 70px 1fr;
  grid-template-rows: repeat(3, auto);
  padding: 0 25px 20px;
  max-width: 320px;
  width: 100%;
  margin: 0 auto;
  gap: 5px;
`

export const JackpotContent = styled.div`
  grid-area: content;
`

export const ErrorMessage = styled.div`
  font-size: 14px;
  color: ${COLOURS.secondaryRed1};
  margin-top: 10px;
`
